import styled from 'styled-components'
import { Card } from 'antd'
export const SmallPaddingCard = styled(Card)`
  /* .ant-card-head {
    padding:'16px 16px 0'
  } */
  .ant-card-body {
    padding: 16px;
  }
`
